import { inject } from '@angular/core';
import { CanActivateFn, Router, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ShellComponent } from './layout/shell/shell.component';
import {QrGeneratorComponent} from './pages/ts-export/ts-export.component';
import {RouteGuardService} from './services/route-guard.service';
import {AuthService} from './services/auth.service';

const redirectLoggedUserToQr: CanActivateFn = () => {
  const auth = inject(AuthService);

  if (!auth.isUserLogged()) {
    return true;
  }

  return inject(Router).createUrlTree(['/home/qr-code']);
};

export const routes: Routes = [
  { path: '', redirectTo: 'home/qr-code', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [redirectLoggedUserToQr] },
  {
    path: 'home',
    component: ShellComponent,
    canActivate: [RouteGuardService],
    children: [
      { path: '', redirectTo: 'qr-code', pathMatch: 'full' },
      { path: 'qr-code', component: QrGeneratorComponent }
    ],
  },
  { path: '**', redirectTo: 'home/qr-code' },
];
